import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import english from "../locales/language_en.json";
import arbic from "../locales/language_ar.json";
import { properties } from "./Properties";

function getLiferayLanguageChoice() {
  try {
    const languageId = properties.languageId;
    return languageId.split("_")[0];
  } catch (error) {
    return "en"; //Fallback language
  }
}

i18next.use(initReactI18next).init({
  lng: getLiferayLanguageChoice(),
  fallbackLng: "en",
  resources: {
    en: english,
    ar: arbic,
  },
  react: {
    useSuspense: false,
  },
});

export default i18next;
